export const dynamicVariableRegex =
    /\{\{\s*(?:source:\s*([a-zA-Z0-9_.-]+)\s*,\s*value:\s*([^,}]+)\s*,\s*type:\s*([a-zA-Z0-9_.-]+)|value:\s*([^,}]+)\s*,\s*source:\s*([a-zA-Z0-9_.-]+)\s*,\s*type:\s*([a-zA-Z0-9_.-]+)|type:\s*([a-zA-Z0-9_.-]+)\s*,\s*source:\s*([a-zA-Z0-9_.-]+)\s*,\s*value:\s*([^,}]+))\s*\}\}/g

export const isDynamicVariable = (value: string) => {
    const newRegex = new RegExp(dynamicVariableRegex)
    return newRegex.test(value)
}

export const getDynamicVariableValue = (value: string): { source: string; value: string; type: string } => {
    if (!value) {
        return {
            source: '',
            value: '',
            type: '',
        }
    }
    const newRegex = new RegExp(dynamicVariableRegex)
    const match = newRegex.exec(value)

    if (!match) {
        console.error('Invalid dynamic variable format', value)
        return {
            source: '',
            value: '',
            type: '',
        }
    }

    if (match[1]) {
        // source,value,type order
        return {
            source: match[1],
            value: match[2],
            type: match[3],
        }
    } else if (match[4]) {
        // value,source,type order
        return {
            source: match[5],
            value: match[4],
            type: match[6],
        }
    } else {
        // type,source,value order
        return {
            source: match[8],
            value: match[9],
            type: match[7],
        }
    }
}

export const blockVariableRegex =
    /\{\{\s*(?:block:\s*([a-zA-Z0-9_.-]+)\s*,\s*source:\s*([a-zA-Z0-9_.-]+)\s*,\s*value:\s*([^,}]+)\s*,\s*type:\s*([a-zA-Z0-9_.-]+)|block:\s*([a-zA-Z0-9_.-]+)\s*,\s*value:\s*([^,}]+)\s*,\s*source:\s*([a-zA-Z0-9_.-]+)\s*,\s*type:\s*([a-zA-Z0-9_.-]+)|block:\s*([a-zA-Z0-9_.-]+)\s*,\s*type:\s*([a-zA-Z0-9_.-]+)\s*,\s*source:\s*([a-zA-Z0-9_.-]+)\s*,\s*value:\s*([^,}]+)|source:\s*([a-zA-Z0-9_.-]+)\s*,\s*value:\s*([^,}]+)\s*,\s*type:\s*([a-zA-Z0-9_.-]+)|value:\s*([^,}]+)\s*,\s*source:\s*([a-zA-Z0-9_.-]+)\s*,\s*type:\s*([a-zA-Z0-9_.-]+)|type:\s*([a-zA-Z0-9_.-]+)\s*,\s*source:\s*([a-zA-Z0-9_.-]+)\s*,\s*value:\s*([^,}]+))\s*\}\}/g

export const isBlockVariable = (value: string) => {
    const newRegex = new RegExp(blockVariableRegex)
    return newRegex.test(value)
}

export const getBlockVariableValue = (
    value: string
): { block?: string; source: string; value: string; type: string } => {
    if (!value) {
        return {
            source: '',
            value: '',
            type: '',
        }
    }
    const newRegex = new RegExp(blockVariableRegex)
    const match = newRegex.exec(value)

    if (!match) {
        console.error('Invalid dynamic variable format', value)
        return {
            block: '',
            source: '',
            value: '',
            type: '',
        }
    }

    if (match[1]) {
        // block,source,value,type order
        return {
            block: match[1],
            source: match[2],
            value: match[3],
            type: match[4],
        }
    } else if (match[5]) {
        // block,value,source,type order
        return {
            block: match[5],
            source: match[7],
            value: match[6],
            type: match[8],
        }
    } else if (match[9]) {
        // block,type,source,value order
        return {
            block: match[9],
            source: match[11],
            value: match[12],
            type: match[10],
        }
    } else if (match[13]) {
        // source,value,type order (no block)
        return {
            source: match[13],
            value: match[14],
            type: match[15],
        }
    } else if (match[16]) {
        // value,source,type order (no block)
        return {
            source: match[17],
            value: match[16],
            type: match[18],
        }
    } else {
        // type,source,value order (no block)
        return {
            source: match[20],
            value: match[21],
            type: match[19],
        }
    }
}

export const getAllDynamicVariableValues = (value: string): Array<{ source: string; value: string; type: string }> => {
    if (!value) {
        return []
    }

    const newRegex = new RegExp(dynamicVariableRegex, 'g')
    const results = []
    let match

    while ((match = newRegex.exec(value)) !== null) {
        if (match[1]) {
            // source,value,type order
            results.push({
                source: match[1],
                value: match[2],
                type: match[3],
            })
        } else if (match[4]) {
            // value,source,type order
            results.push({
                source: match[5],
                value: match[4],
                type: match[6],
            })
        } else {
            // type,source,value order
            results.push({
                source: match[8],
                value: match[9],
                type: match[7],
            })
        }
    }

    return results
}
